import OpenAPIClientAxios from 'openapi-client-axios';
import definition from '@stefna/checkit-openapi-specification/dist/schema.json';

let server;
if (process.env.STAGING) {
  server = 'staging';
}
else {
  server = process.env.PROD ? 'production' : 'staging';
}

const api = new OpenAPIClientAxios({
  definition,
  withServer: server,
  validate: true,
  axiosConfigDefaults: {
    headers: {
      Authorization: `Bearer ${process.env.ACCESS_TOKEN}`,
      'Content-Type': 'application/json;charset=UTF-8',
    },
  },
});

api.init();

export default api;
